/**
 * Utility per gestire altezze dinamiche degli elementi
 * Aspetta che l'elemento sia presente nel DOM (anche se renderizzato da Vue)
 * e calcola l'altezza disponibile per permettere lo scroll interno
 */

// Aspetta che l'elemento venga inserito nel DOM da Vue
function waitForElement(selector, callback) {
    const element = document.querySelector(selector);

    if (element) {
        callback(element);
        return;
    }

    // Observer per aspettare che l'elemento venga inserito nel DOM
    const observer = new MutationObserver(function(mutations, obs) {
        const element = document.querySelector(selector);
        if (element) {
            obs.disconnect();
            callback(element);
        }
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
}

// Funzione per calcolare e applicare l'altezza dinamica
function setupDynamicHeight(container) {
    function updateHeight() {
        // Calcola la distanza dall'inizio della pagina
        const rect = container.getBoundingClientRect();
        const offsetTop = rect.top + window.scrollY;

        // Applica l'altezza fissa per permettere lo scroll interno
        const height = `calc(100vh - ${offsetTop}px)`;
        container.style.height = height;
        container.style.maxHeight = height;
        container.style.minHeight = height;
    }

    // Esegui al setup
    updateHeight();

    // Ricalcola su resize della finestra
    window.addEventListener('resize', updateHeight);

    // Ricalcola dopo un breve delay per permettere al layout di stabilizzarsi
    setTimeout(updateHeight, 100);
    setTimeout(updateHeight, 300);
}

// Inizializza l'altezza dinamica per tutti gli elementi con classe .card-h-full
export function initDynamicHeights() {
    // Cerca tutti gli elementi con la classe card-h-full
    const elements = document.querySelectorAll('.card-h-full');

    if (elements.length > 0) {
        // Se gli elementi esistono già, applica subito
        elements.forEach(element => setupDynamicHeight(element));
    }

    // In ogni caso, aspetta anche elementi che potrebbero essere aggiunti dopo
    waitForElement('.card-h-full', function(container) {
        setupDynamicHeight(container);
    });
}

// Esporta le funzioni per poterle usare anche manualmente
export { waitForElement, setupDynamicHeight };
